import type { TranslationKeys } from '../localeType';

export const daDK: TranslationKeys = {
  // All Pages
  addAccessories: 'Tilføj flere tilbehør',
  all: 'Alle',
  checkAll: 'Vælg alle',
  anyFloristFounded: 'Ingen blomsterhandler fundet',
  backToOrderList: 'Tilbage',
  cancel: 'Annuller',
  catalog: 'Katalog',
  catalogAbroad: 'Udenlandsk produktkatalog',
  closed: 'Lukket',
  communications: 'Kommunikation',
  date: 'Dato',
  download: 'Download',
  downloadLabel: 'Download etiket',
  endDate: 'Slutdato',
  goToOrders: 'Gå til dine ordrer',
  goToOrder: 'Gå til ordre',
  history: 'Historik',
  hour: 'Time',
  inProgress: 'I gang',
  isModified: 'Ændret',
  isReady: 'Buket klar',
  ITContact: 'Interflora kontakt',
  loginAs: 'Logget ind som',
  modify: 'Rediger',
  new: 'Ny',
  noDocuments: 'Ingen dokumenter fundet med disse filtre:',
  noOrderInTab: 'Ingen ordrer i denne fane',
  noOrdersFound: 'Ingen ordre matcher denne søgning',
  nothingFound: 'Intet fundet',
  open: 'Åben',
  orderDefault: 'Ordre',
  orders: 'Ordrer',
  partner: 'Partnerwebsteder',
  price: 'Pris',
  startDate: 'Startdato',
  suspendedFlorist: 'Inaktiv blomsterhandler',
  to: 'til',
  and: 'og',
  today: 'I dag',
  unknown: 'Ukendt',
  validate: 'Bekræft',
  save: 'Gem',
  view: 'Vis',
  close: 'Luk',
  actionImpossible: 'Ikke tilgængelig',
  listView: 'Listevisning',
  listViewTooltip: 'Denne knap viser listen',
  mapView: 'Kortvisning',
  mapViewTooltip: 'Denne knap viser kortet',
  viewOnMap: 'Vis på kortet',
  true: 'Ja',
  false: 'Nej',
  delete: 'Slet',
  warning: 'Advarsel',
  courierDeliveryOrderWarning: 'Du handler på en ordre, der oprindeligt var planlagt til kurerleverance!',
  putOrderInProgress: 'Aktivér status "I gang"',
  removeOrderInProgress: 'Deaktivér status "I gang"',
  actionUnavailable: 'Handlingen er ikke mulig',

  markAsPrint: {
    validMarkAsPrint: 'Ordrerne er blevet markeret som printet.',
    validUnmarkAsPrint: 'Ordrerne er blevet markeret som ikke printet.',
    warning: 'Nogle ordrer kunne ikke ændre status',
    undoMarkAsPrint: 'Fjern Printet status',
    undoUnmarkAsPrint: 'Gendan Printet status',
  },

  print: {
    title: 'Udskriv nye ordrer',
    titleQuick: 'Hurtig udskrivning',
    printed: 'Printet',
    printTooltip: 'Denne knap giver mulighed for at udskrive ordresedler, der endnu ikke er blevet printet',
    printedError: 'Der opstod en fejl, prøv igen senere.',
    printedErrorMessage: 'Nogle ordrer kan ikke udskrives.',
    partiallyPrinted: 'Nogle fakturaer kunne ikke udskrives.',
    nothingToPrint: 'Ingen fakturaer at udskrive.',
    markAsPrint: 'Ordren er blevet markeret som printet.',
    markAsPrintPlural: 'Ordrerne er blevet markeret som printede.',
    popup: {
      title: 'Markér som printet?',
      titlePlural: 'Markér som printede?',
      validate: 'Markér som printet',
      validatePlural: 'Markér som printede',
      cancel: 'Markér ikke',
      textQuickPrint: `Du brugte hurtig udskrivning. Vil du markere disse ordrer som Printede for at undgå genudskrivning via hurtig udskrivning?`,
      textMultiSelect: `Du har anmodet om udskrivning af flere ordrer. Vil du markere dem som Printede for at undgå genudskrivning via hurtig udskrivning?`,
      textSinglePrint: `Vil du markere den ordre, hvis ordreseddel du netop har set, som Printet for at undgå genudskrivning via hurtig udskrivning?`,
    },
  },

  // Homepage
  message: {
    welcome: 'Velkommen, {name} \ud83c\udf3b',
  },
  ordersHome: {
    today: 'Ordrer for i dag',
    tomorrow: 'Ordrer for i morgen',
    later: 'Ordrer til senere',
    late: 'Forsinkede ordrer',
  },
  orderHome: {
    today: 'Ordre for i dag',
    tomorrow: 'Ordre for i morgen',
    later: 'Ordre til senere',
    late: 'Forsinket ordre',
  },
  linkNewsLabel: 'Se alle nyheder',
  seeMore: 'Se mere',
  seeLess: 'Se mindre',
  seeHistory: 'se historik',
  NoNotification: 'Ingen notifikationer',
  explanation: {
    title: 'Introduktion til Iris',
    content: `Velkommen til din nye blomsterhandlerplatform.
Vi vil minde dig om, at dette ikke er den endelige version, vores arbejde er stadig i gang.
I denne fase er din feedback afgørende.
Vi vil på forhånd takke dig for din forståelse og tålmodighed.`,
  },
  newCollectionHome: 'Den aktuelle kollektion',

  // Nav
  nav: {
    admin: 'Min konto',
    contact: 'Kontakt',
    deliveries: 'Leverancer',
    history: 'Historik',
    home: 'Hjem',
    internalUser: 'Intern bruger',
    orders: 'Ordrer',
    page: 'Min butik',
    QrCode: 'Ordrevalidering',
    signOut: 'Log ud',
    transmissions: 'Transmissioner',
    faq: 'Stil spørgsmål,',
    xlFlorist: 'Blomsterhandler XL',
  },

  // Orders
  details: {
    download: 'Download som PDF',
    delivered: 'Marker som leveret',
    absent: 'Marker som fraværende',
    reassign: 'Tildel igen',
    additional: 'Yderligere oplysninger',
    accept: 'Accepter',
    refuse: 'Afvis',
    addInfo: 'Tilføj noter',
    assignToCourier: 'Tildel til en kurer',
    cancel: 'Annuller ordre',
    customerErrorMessage: 'Kan ikke vise ordreformularen',
    cancelDelivery: 'Annuller levering',
    recipient: {
      title: 'Modtager og leveringsoplysninger',
      label: {
        additionalStreetInfo: 'Adressetillæg',
        address: 'Adresse',
        colivex: 'Levering til gravsted',
        contactName: 'Kontaktnavn',
        country: 'Land',
        companyName: 'Leveringssted...',
        deceasedName: 'Den afdødes navn',
        deliveryDate: 'Leveringsdato',
        deliveryLocation: 'Leveringssted...',
        deliveryMoment: 'Leveringstidspunkt',
        deliveryTime: 'Leveringstid',
        event: 'Begivenhed',
        infos: 'Tilf. info',
        instructions: 'Instruktioner',
        name: 'Navn',
        phone: 'Telefon nr.',
        postalCode: 'Postnummer',
        prelimeryAgreement: 'Forudgående aftale', //not used in Italy
        region: 'Region',
        town: 'By',
      },
    },
    order: {
      title: 'Ordredetaljer',
      label: {
        legacyOrderId: 'Ordre-id ISOWEB',
        orderStatus: 'Ordrestatus',
        orderDate: 'Ordredato',
        price: 'Pris',
        deliveryCost: 'Leveringsomkostninger',
        trackingCode: `Forsendelseskode`,
      },
      status: {
        NEW_ORDER: 'Ny ordre',
        ASSIGNED: 'Tildelt',
        ACCEPTED: 'Accepteret',
        REFUSED: 'Afvist',
        ASSIGNATION_NOT_POSSIBLE: 'Tildeling ikke mulig',
        NOT_PRINTED: 'Ikke printet',
        PRINTED: 'Printet',
        IN_PROGRESS: 'I gang',
        INTERNAL_COURRIER: 'Intern kurer',
        EXTERNAL_COURRIER: 'Ekstern kurer',
        DELIVERED: 'Leveret',
        ABSENT: 'Fraværende',
        CANCELLED: 'Annulleret',
        SENT: 'Sendt',
        REASSIGN: 'Tildelt igen',
      },
      notes: {
        addNote: 'Tilføj note',
        addPhoto: 'Tilføj et foto',
        anythingElse: 'Tilføj din note',
        create: 'Opret en note',
        delivery: 'Levering',
        deliveryChanges: 'Leveringsændringer?',
        deliveryDetail: 'Angiv leveringsdetaljer',
        emptyNoteList: 'Du har ingen noter',
        imageCategory: 'Billedkategori',
        notValidatedNote: 'Umuligt at opdatere status for denne ordre',
        product: 'Produkt',
        title: 'Tilføj noter',
        titleAddNotes: 'Tilføj noter',
        titleSetAsDelivered: 'Bekræft en levering',
        confirmSetAsDelivered: 'Er du sikker på, at du vil markere de {count} valgte ordrer som leveret?',
        emptyPhotos: 'Du har ingen fotos',
        validatedNote: 'Noten er oprettet',
        validatedOrderNote: 'Ordren er valideret',
        dragAndDrop: 'Træk og slip dit billede her',
        or: 'eller',
        browseFiles: 'Gennemse filer',
        uploadPhoto: 'Upload foto',
        addPhotoOptionnal: 'Tilføj et foto (valgfrit)',
      },
      delivery: {
        inProgress: {
          status: 'Leveringsstatus:',
          momentTitle: 'Dato og tid: ',
          moment: '{date} - Mellem {hour} og {hourPlusOne}',
          price: 'Pris:',
          from: 'af',
        },
        cancel: {
          title: 'Annuller levering',
          body: 'Denne handling vil annullere den eksterne leveringstjeneste, der er tildelt denne ordre.',
          bodyInternalDelivery: 'Denne handling vil annullere den interne levering, der er knyttet til denne ordre.',
          buttonSecondary: 'Fortryd',
          buttonPrimary: 'Bekræft',
        },
      },
      modifications: {
        title: 'Modified order details',
        tooltip: 'Click for updates',
        modalTitle: 'Updates',
        noChanges: 'Cannot display order modifications',
        markAsRead: 'Mark as read',
      },
      invoicePrintedLabel: {
        yes: 'Udskrevet',
        no: 'Ikke udskrevet',
      },
      invoicePrintedTooltip: {
        yes: 'Denne ordre er udskrevet',
        no: 'Denne ordre er endnu ikke udskrevet',
      },
      recipientSmsStatus: {
        sent: {
          label: 'SMS sendt',
          fullLabel: 'SMS sendt',
          tooltip: 'En SMS-notifikation er sendt til modtageren',
        },
        resent: {
          label: 'SMS gensendt',
          fullLabel: 'SMS gensendt',
          tooltip: 'SMS-notifikationen er blevet gensendt til modtageren',
        },
        expired: {
          label: 'SMS udløbet',
          fullLabel: 'SMS udløbet',
          tooltip: 'SMS-notifikationen er udløbet',
        },
        validatedByPhone: {
          label: 'Bekræftet via telefon',
          fullLabel: 'Bekræftet via telefon',
          tooltip: 'Blomsterhandleren har bekræftet leveringen via telefonopkald',
        },
        validatedBySms: {
          label: 'Bekræftet via SMS',
          fullLabel: 'Bekræftet via SMS',
          tooltip: 'Modtageren har bekræftet leveringen via SMS-linket',
        },
      },
      recipientSmsAction: {
        removeValidation: 'Fjern bekræftelse',
        resendSms: 'Gensend SMS',
        validateByPhone: 'Markér som bekræftet via telefonopkald',
      },
      recipientSmsActionHint: {
        temporaryUnavailable: 'Gensendelse er midlertidigt utilgængelig',
        smsAlreadyResent: "SMS'en er allerede blevet gensendt",
      },
    },
    florist: {
      title: {
        executor: 'Udførende blomsterhandler',
        transmitter: 'Afsendende blomsterhandler',
      },
      label: {
        name: 'Navn',
        id: 'Identifikator',
        Phone: 'Telefon nr.',
        Email: 'E-mail',
        SecondEmail: 'E-mail',
      },
    },

    ribbon: {
      title: 'Bånd',
      text: 'Båndtekst: ',
    },

    buyer: {
      title: 'Køber',
      label: {
        name: 'Navn',
        phone: 'Telefon nr.',
        email: 'E-mail',
      },
    },

    header: {
      productCode: 'Produktkode',
      quantity: 'Antal',
      size: 'Størrelse',
      description: 'Beskrivelse',
      price: 'Pris',
      image: 'Billede',
      composition: 'Sammensætning',
      moreProducts: 'Flere produkter',
      accessory: 'Tilbehør',
    },
    message: {
      title: 'Beskedkort',
      label: {
        message: 'Besked',
        signature: 'Underskrift',
      },
    },
    additionalImages: 'Gemte fotos',
    recipientNotes: {
      title: 'Modtagernoter',
      cardTitle: 'Modtagernote',
      cardTitleModified: 'Ny modtagernote',
      canBeLeft: 'Ordren kan efterlades uden opsyn.',
      cannotBeLeft: 'Ordren kan ikke efterlades uden opsyn.',
    },
  },

  // Transmissions
  transmission: {
    title: 'Ordretransmissioner',
    new: 'Ny transmission:',
    locale: 'Lokal',
    abroad: 'Udland',

    table: {
      no: 'Nr.',
      id: 'Ordrenummer',
      product: 'Produkt',
      recipient: 'Modtager',
      town: 'By',
      status: 'Status',
      date: 'Dato',
    },
    form: {
      deliveryAddressCemeteryWarning: `Leveringsadressen ser ud til at være en kirkegård, men indstillingen 'Gravlevering' er ikke valgt. Vil du fortsætte?`,
      cemetery: 'kirkegård',
      sended: 'Formularen er sendt',
      notSended: 'Formularen blev ikke sendt',
      country: 'Land',
      mandatoryFields: 'Obligatoriske felter',
      noProductsForCountry: 'Ingen produkter fundet for dette land',
      freePrice: {
        title: 'Fri pris',
        low: 'Fri pris for lav',
        entry: 'Angiv en fri pris',
        from: 'Produkt med fri pris mulig fra',
        integer: `Øre accepteres ikke af det internationale system`,
      },
      emailNotValid: 'E-mail ikke gyldig. Eksempel: %{email}',
      phoneNotValid: 'Telefon ikke gyldig', //. example: %{phone}
      delivery: {
        additionalStreetInfo: 'Adressetillæg',
        address: 'Adresse',
        addressComplement: 'Yderligere oplysninger',
        city: 'By',
        cityPostalCode: 'By eller postnummer',
        deliveryInstructions: 'Leveringsinstruktioner',
        extra: 'Ekstra',
        feasible: 'Det er muligt at udføre denne ordre!',
        foreignAddress: `Da udenlandske adresser ikke kan verificeres, bedes du angive den mest fuldstændige adresse`,
        guarantee: '*Kun dag er garanteret',
        isBillNeeded: 'Regning nødvendig',
        isCeremony: 'Er det til en ceremoni?',
        no: 'Nej',
        notFeasible: 'Ingen mulig match for denne ordre!',
        notFound: ' Adresse ikke fundet',
        place: 'Stedets navn',
        psm: 'Tilpassede produktoplysninger',
        slot: 'Leveringstidsrum',
        streetName: 'Vejnavn',
        streetNumber: 'Vejnummer',
        title: 'Levering',
        toGrave: 'Lever til gravsted',
        yes: 'Ja',
        zipCode: 'Postnummer',
        errorAddressAndLocality: `Adressen stemmer ikke overens med den valgte destination {locality} ovenfor`,
        date: {
          title: 'Leveringsdato',
          today: 'I dag',
          tomorrow: 'I morgen',
          later: 'Senere',
          selectedDate: 'Valgt dato: ',
        },
      },

      productDetail: 'Produkt',
      selectSize: 'Vælg størrelse',
      orderType: {
        title: 'Ordretype',
        regular: 'Normal',
        funeral: 'Begravelse',
      },
      contact: {
        additionalStreetInfo: 'Yderligere oplysninger',
        address: 'Adresse',
        buyerTitle: 'Køberoplysninger',
        city: 'By',
        companyName: 'Firmanavn',
        contactTitle: 'Kontaktoplysninger',
        deceased: 'Afdød',
        email: 'E-mail',
        firstName: 'Fornavn',
        fiscalCode: 'CVR-nummer',
        lastName: 'Efternavn',
        phone: 'Telefon',
        title: 'Kontakt',
        zipCode: 'Postnummer',
      },
      message: {
        title: 'Beskedkort',
        message: 'Besked',
        signature: 'Underskrift',
      },
      accessory: {
        addAccessory: 'Tilføj tilbehør',
        addMoreAccessories: 'Tilføj flere tilbehør',
        changeAccessory: 'Skift',
        label: 'Tilbehør',
        noAccessory: 'Intet tilbehør valgt',
        removeAccessory: 'Fjern',
        select: 'Vælg et tilbehør',
        title: 'Tilbehør',
        needRibbonText: 'Tilføj et bånd?',
        ribbonText: 'Indtast teksten til båndet',
      },
      summary: {
        title: 'Oversigt: ',
        productTotal: 'Produkttotal:',
        accessoriesTotal: 'Tilbehørstotal:',
        deliveryCost: 'Leveringsbeløb:',
        total: 'Total: ',
        transmissionFormComplete: 'Transmissionsformularen er komplet',
        stepper: {
          productDetails: 'Produktdetaljer',
          deliveryAddress: 'Leveringsadresse',
          deliveryDate: 'Leveringsdato',
          feasability: 'Gennemførlighed',
          recipientInfo: 'Modtageroplysninger',
          buyerInfo: 'Køberoplysninger',
          feasabilityOK: 'Gennemførlighed er OK',
        },
      },
      assignation: {
        title: 'Blomsterhandlertildeling',
        select: 'Vælg venligst tildelingstype',
        zone1: 'Primær',
        zone2: 'Reserve',
        zone3: 'Stor zone',
        displayZone3: 'Vis liste over ',
        automatic: 'Automatisk',
        manual: 'Manuel',
        floristNumber: 'Blomsterhandlernummer',
        floristNumberError: `Medlemsnummerets format er ikke som forventet`,
        floristNumberSupporting: 'Medlemsnummeret skal starte med 00',
        validationCode: 'Valideringskode',
        mandatoryValidationCode: 'Valideringskode er obligatorisk for dette produkt',
        table: {
          floristName: 'Blomsterhandlernavn',
          phone: 'Telefon nr.',
          quality: 'Kvalitetsbonus',
          distance: 'Afstand',
        },
      },
      color: {
        select: 'Vælg en farve',
        nbOfFlowers: 'Antal blomster',
        price: 'Pris',
      },
      psp: {
        title: 'Betaling',
        paymentOK: 'Betaling gennemført! Du kan nu fortsætte med transmissionen.',
        paymentKO: 'Betaling mislykkedes',
        paymentLinkExprired: 'Betalingslinket er udløbet. Generer et nyt ved at vælge betalingstype.',
        linkAlreadyExist:
          'Det ser ud til, at du allerede har genereret et betalingslink med bankkort. Sørg for, at klienten ikke bruger det igen for at undgå dobbeltbetaling.',
        linkTime: 'Resterende tid inden betalingslinket udløber: {time}',
        paymentDone: 'Betaling gennemført, du kan klikke på Bekræft for at sende transmissionen',
        selectPayment: {
          title: 'Vælg betalingstype',
          cash: 'Kontant',
          bankCard: 'Bankkort',
        },
        paymentLink: {
          title: 'Vælg hvordan betalingslinket sendes til kunden',
          otherTab: 'Åbn i en ny fane',
          sms: 'Send SMS',
          QrCode: 'Generer QR-kode',
        },
        otherTab: {
          title: 'Betalingslink i en anden fane',
          explaination:
            'Betalingssiden åbnes i en ny fane for din kunde. Vi giver dig besked, når betalingen er gennemført eller udløbet, så du kan fortsætte.',
        },
        sms: {
          title: 'Betalingslink via SMS',
          send: 'Send SMS',
          explaination:
            'Et betalingslink er sendt til kunden via SMS. Vi giver dig besked, når betalingen er gennemført eller udløbet, så du kan fortsætte.',
          smsSendError: 'Der opstod en fejl under afsendelse af SMS',
          smsSendImpossible: `Det er ikke muligt at sende SMS`,
          paymentLinkMessage: 'Interflora takker dig for din tillid. Her er linket til at betale for din ordre. ',
        },
        qrCode: {
          title: 'Betalingslink via QR-kode',
          explaination:
            'Kunden kan scanne QR-koden for at tilgå betalingslinket. Når betalingen er gennemført eller udløbet, giver vi dig besked, så du kan fortsætte med transmissionen.',
        },
      },
    },
    quickCheck: {
      title: 'Kontroller en destination',
      label: 'Vælg en destination',
      notFeasible: 'Denne destination er ikke tilgængelig for videresendelse.',
      feasible: `Denne destination er tilgængelig for videresendelse. \nKlik på "Fortsæt videresendelse" for at tilgå formularen.`,
      accessForm: 'Fortsæt videresendelse',
    },
  },

  // OrderList
  delivered: 'Leveret',
  absent: 'Fraværende',
  seeDetails: 'Se detaljer',
  hideDetails: 'Skjul detaljer',
  multiproducts: 'produkter',
  order: {
    search: 'Hvad leder du efter?',
    searchTooltip: 'Brug denne knap til at søge efter en ordre',
    loadingOrders: 'Indlæser ordrer...',
    quickActions: {
      absent: 'Modtager fraværende',
      accept: 'Accepter',
      acceptAndPrint: 'Accepter og print',
      assignToCourier: 'Tildel til kurer',
      clear: 'Ryd valg',
      delivered: 'Leveret',
      reassign: 'Tildel igen',
      refuse: 'Afvis',
      tooLate: 'For sent at acceptere',
      downloadCSV: 'Download CSV',
      print: 'Print',
      noOrderSelected: 'Vælg flere ordrer for at udføre massehandlinger',
      noOrderSelectedShort: 'Ingen ordre valgt',
      openToolbar: 'Åbn multi-markering',
      closeToolbar: 'Annuller multi-markering',
      ordersSelected: '{nbOrders} ordrer valgt',
      acceptAll: 'Accepter hele udvalget',
      acceptAndPrintAll: 'Accepter og udskriv',
      cancelDelivery: 'Annuller levering',
      feedback: {
        cancelDeliveryOK: `Den eksterne levering er blevet annulleret, og ordren er flyttet til ordrefanen.`,
        cancelInternalDeliveryOK: `Den interne levering er blevet annulleret, og ordren er flyttet til fanen »Ordrer«.`,
        cancelDeliveryKO: `Umuligt at annullere den eksterne levering.`,
        cancelInternalDeliveryKO: `Det er ikke muligt at annullere den interne levering.`,
      },
    },
    title: 'Ordreliste',
    noStatusBanner: {
      mainText: `{count} ordre, hvis leveringstidsvindue er ved at udløbe, har ikke status "Leveret" eller "Modtager fraværende". | {count} ordrer, hvis leveringstidsvindue er ved at udløbe, har ikke status "Leveret" eller "Modtager fraværende".`,
      subText: `Bag hver ordre venter nogen på at vide, om deres blomster er ankommet. Har du husket at opdatere dem?`,
    },
    table: {
      no: 'Nr.',
      deliveryDate: 'Leveringsdato',
      deliveryTime: 'Leveringstid',
      id: 'Ordrenummer',
      product: 'Produkt',
      price: 'Pris',
      town: 'By',
      recipient: 'Modtager',
      preparing: 'I gang',
      invoice: 'Fakturaer',
      actions: 'Handlinger',
      deliveryService: 'Leveringstjeneste',
      reason: 'Årsag',
      openDetail: 'Åbn detalje',
      closeDetail: 'Luk detalje',
      deliveryDetails: 'Leveringsdetaljer',
      address: 'Adresse',
      phone: 'Telefonnummer',
      goToOrderDetail: 'Gå til ordredetaljesiden',
      instructions: 'Leveringsinstruktioner',
    },
    modal: {
      refuse: {
        title: 'Vil du afvise denne ordre?',
        reason: {
          reason1: 'Prisen er for lav',
          reason2: 'Min butik er lukket',
          reason3: `Jeg kan ikke levere`,
          reason4: `Jeg har ikke dette produkt`,
        },
      },
      absent: {
        title: `Hvorfor kunne ordren ikke leveres?`,
        subtitle: `Hvorfor kunne ordren ikke leveres?`,
        reason: {
          DANOREP: 'Modtager er ikke tilgængelig',
          DADATEULT: 'Modtager har ændret leveringsdatoen',
          DAREFUS: 'Modtager har afvist ordren',
          DANOINFO: 'Manglende oplysninger til levering af ordren',
        },
      },
      reassign: {
        title: 'Vil du tildele denne ordre igen?',
        reason: {
          PCO: 'Manglende påkrævede farver',
          PFO: 'Manglende påkrævede blomster',
          PL: 'Ingen leveringsperson tilgængelig',
          LL: 'Levering for langt væk',
          RT: 'Modtaget for sent',
          PAM: 'Ikke mere lager i butikken',
        },
      },
      delivery: {
        title: 'Vælg en leveringstjeneste',
        intro: 'Vælg en leveringsservice til ordre <b>{orderId}</b>.',
        introMultiOrders: 'Vælg en leveringsservice til de {count} ordrer.',
        deliveryCost:
          'Pris {deliveryService}({serviceAmount}) - Leveringsgebyr({itfAmount}) = Eget udlæg({totalPrice})',
        delay: 'Tilgængelig om {noticePeriod}',
        availableImmediately: 'Straks tilgængelig',
        includedDeliveryPrice: 'Inkluderet i din leveringspakke',
        serviceUnavailable: 'Tjeneste utilgængelig',
        selectYourSlot: 'Vælg tidsrummet',
        deliverOrder: 'Lever ordren {orderId}',
        deliveryInstructions: 'Noget der kan lette leveringen',
        validated: `Ordre {orderId} er sendt til {service} !\nTjek leveringsstatus under leveringsfanen`,
        internalValidated: `Ordren er tildelt {username} og flyttes over til fanen »Levering«.`,
        internalMultipleOrdersValidated: `Ordrerne er tildelt {username} og flyttes over til fanen »Levering«.`,
        dateTooFar: `Den foreslåede leveringsdato er for langt fremme. Prøv igen om et par dage.`,
        errorOnValidation: 'Kan ikke oprette levering for ordre {orderId}',
        errorOnMultipleOrdersValidation: 'Det er ikke muligt at oprette leveringen for ordrerne.',
      },
    },
    multiSelect: {
      delivered: {
        allDelivered: '{count} ordrer er blevet markeret som leveret. De er nu flyttet til ordrehistorikken.',
        someNotUpdated: 'Nogle af dine ordrer kunne ikke opdateres.',
        noneUpdated: 'Ingen af de valgte ordrer har ændret status.',
      },
      accept: {
        all: '{count} ordrer er blevet accepteret med succes. De er nu flyttet til ordrefanen.',
        someNotUpdated: 'Nogle af dine ordrer kunne ikke accepteres.',
        noneUpdated: 'Ingen af de valgte ordrer er blevet accepteret.',
        waiting: 'Behandling i gang, vent venligst...',
      },
    },
    floristToggle: {
      changeStateTooltip: 'Skift ordrestatus',
      backToInitial: 'Tilbage til initial status',
      initial: {
        label: 'Initial',
      },
      inProgress: {
        label: 'I gang',
      },
      ready: {
        label: 'Buket klar',
        lockedHint: 'Tilgængelig kun 2 timer før leveringstidsrummet',
      },
    },
  },

  // pager
  pager: {
    itemsPerPage: '{counter} / side',
  },

  // My page
  myPage: {
    title: 'Min side',
    calendarManagement: 'Kalenderstyring',
    infoManagement: 'Informationsstyring',
    notFound: 'Blomsterhandleroplysninger ikke fundet',
    accessories: {
      accessoriesAction: 'Tilgængelighed',
      accessoriesList: 'Tilbehørsliste',
      anyAccessory: 'Intet tilbehør',
      title: 'Tilbehørsstyring',
    },
    hours: {
      title: 'Åbningstider',
      changeOpeningHours: 'Skift dine åbningstider',
      closeAllDayButton: 'Luk hele dagen',
      shopClosed: 'Din butik er lukket denne dag',
      openButton: 'Åben',
      addBreak: 'Tilføj en pause',
      removeBreak: 'Fjern pausen',
      saveButton: 'Gem',
      closingTime: 'Lukketid',
      openingTime: 'Åbningstid',
      breakEnd: 'Pauseslut',
      breakStart: 'Pausestart',
    },
    exceptions: {
      headerTitle: 'Mine undtagelser',
      the: 'Den:',
      from: 'Fra:',
      new: 'Tilføj en undtagelse',
      next: 'Næste undtagelser',
      any: 'Ingen undtagelse',
      title: 'Næste undtagelser',
      to: 'Til:',
    },

    calendar: {
      title: 'Månedsoversigt',
      weeklyCalendar: {
        calendarModified: 'Din kalender er blevet opdateret',
        clickToChange: 'Klik for at åbne eller lukke*',
        closed: 'Lukket',
        closedAM: 'Lukket om morgenen',
        closedPM: 'Lukket om eftermiddagen',
        editWeek: 'Rediger din ugentlige tidsplan',
        open: 'Åben hele dagen',
        openAM: 'Åben om morgenen',
        openPM: 'Åben om eftermiddagen',
        title: 'Ugentlig kalender',
      },
      massive: {
        title: 'Tilføj masseundtagelser',
        years: 'År',
        months: 'Måneder',
        days: 'Dage',
        morning: 'Morgen',
        afternoon: 'Eftermiddag',
        exceptionsSended: 'Undtagelser sendt',
        exceptionsNotSended: `Undtagelser kan ikke registreres`,
      },
    },

    quality: {
      bonus: 'Kvalitetsbonus',
      note: 'Din vurdering',
      noteMini: 'Minimumsvurdering',
      noteMaxi: 'Maksimumsvurdering',
      endPeriod: 'Gyldighedsudløb',
      explainationTitleToMM: 'Min kvalitetsbonus og mine videretildelinger',
      explainationToMM: `Sektionerne "Min kvalitetsbonus" og "Mine videretildelinger" er endnu ikke tilgængelige på Iris.\nVed at klikke på de tilsvarende knapper vil du blive omdirigeret til Min butik, hvor de er tilgængelige.`,
      claims: {
        deliveryDate: 'Dato',
        orderId: 'Ordrenummer',
        productCode: 'Produkt',
        reason: 'Årsag',
        explainationTitleToMM: 'Siden "Min ydelsessporing" er under opbygning',
        explainationToMM: 'Den vil snart samle alle dine nøglemålinger i et komplet og forbedret dashboard.',
      },
      title: {
        general: 'Generelt',
        advertissement: 'Reklame / Mærkefremmende',
        quality: 'Servicekvalitet',
        availability: 'Tilgængelighed',
        tools: 'Værktøjer',
      },
    },
    noStock: 'Ikke på lager',
    supplies: {
      title: 'Forsyninger',
      seeCart: 'Se og bekræft min ordre',
      yourOrders: 'Dine ordrer',
      emptyCart: 'Tøm indkøbskurv',
      chooseSupplies: 'Vælg forsyninger',
      modifyChooseSupplies: 'Rediger og vælg forsyninger',
      orderSupplies: 'Forsyningsordrer',
      explainationTitleToMM: 'Dine forsyningsordrer kommer snart til IRIS',
      explainationToMM: `Sektionerne "Forsyningsordrer" og "Mine forsyningsordrer" er endnu ikke tilgængelige på IRIS.\nVed at klikke på de tilsvarende knapper vil du blive omdirigeret til Min butik, hvor du kan se og administrere dine forsyningsordrer.`,
      modal: {
        add: 'Tilføj',
        freeArticles: 'Administrativt (gratis)',
        paidArticles: 'Teknisk - Interflora (betalt)',
        productCode: 'Reference',
        image: 'Forhåndsvisning',
        label: 'Etiket',
        VTACode: 'Momskode',
        price: 'Enhedspris',
        action: 'Handling',
      },
      panel: {
        cart: 'Min indkøbskurv',
        emptyCart: 'Din indkøbskurv er tom',
        total: 'Total : ',
        noOrders: 'Du har ingen ordrer',
      },
    },
    contact: {
      mail: 'Din e-mail',
      mail2: 'Din sekundære e-mail',
      validationCode: 'Din valideringskode',
      address: 'Din adresse',
      phone: 'Dit telefonnummer',
    },
    networkContact: {
      title: 'Din netværksanimator',
      mail: 'Deres e-mail',
      name: 'Deres navn',
      phone: 'Deres telefonnummer',
      phoneAppointment: 'Book en telefonaftale',
    },
    exclusions: {
      title: 'Mine udelukkelser',
      list: `Min udelukkelsesliste`,
      empty: `Du har ingen udelukkelser`,
    },
    claims: {
      title: 'Mine reklamationer',
      empty: `Tillykke! Du har ingen registrerede reklamationer i de seneste 12 måneder`,
    },
    reassignations: {
      title: 'Mine omfordelinger',
      empty: `Du har ingen registrerede omfordelinger i de seneste 6 måneder`,
    },
  },

  info: {
    addHolidaysKO: 'Kan ikke tilføje denne lukkeperiode',
    addHolidaysOK: 'Lukkeperiode tilføjet',
    delHolidaysKO: 'Kan ikke slette denne lukkeperiode',
    delHolidaysOK: 'Lukkeperiode slettet',
    documentKO: 'Kan ikke vise dette dokument',
    documentOK: 'Dokumentet blev åbnet i et andet vindue',
    pending: 'Anmodning i gang',
    documentPending: 'Dokumentet åbnes, vent venligst',
    editField: 'rediger felt',
    nophone: 'Tilføj venligst et telefonnummer',
    nosecondMail: 'Tilføj venligst en e-mail',
    nopersonalCode: 'Tilføj venligst en personlig kode',
    statusKO: 'Kan ikke opdatere status',
    statusOK: 'Status opdateret',
    updatePersonalCodeKO: 'Kan ikke opdatere den personlige kode',
    updatePersonalCodeOK: 'Personlig kode opdateret',
    updatePhoneKO: 'Kan ikke opdatere telefonen',
    updatePhoneOK: 'Telefon opdateret',
    updateSecondEmailKO: 'Kan ikke opdatere e-mailen',
    updateSecondEmailOK: 'E-mail opdateret',
    updateStockKO: 'Kan ikke opdatere lager',
    updateStockOK: 'Lager opdateret',
    postSupplyOK: 'Ordre sendt',
    postSupplyKO: 'Ordre mislykkedes',
    duplicateHolidays: 'En lukning er allerede planlagt for denne periode.',
    photoUploadOK: 'Foto gemt',
    photoUploadKO: 'Kan ikke gemme foto',
    photoUploadTooBig: `Billedet er for stort.
Upload venligst et billede på mindre end 5 MB.`,
    reassignOK: 'Ordre tildelt igen, du vil blive omdirigeret til ordrelisten',
    reassignKO: 'Gentildeling mislykkedes',
  },

  days: {
    initiale: { 1: 'M', 2: 'T', 3: 'O', 4: 'T', 5: 'F', 6: 'L', 0: 'S' },
    short: { 1: 'Man', 2: 'Tir', 3: 'Ons', 4: 'Tor', 5: 'Fre', 6: 'Lør', 7: 'Søn' },
    0: 'Mandag',
    1: 'Tirsdag',
    2: 'Onsdag',
    3: 'Torsdag',
    4: 'Fredag',
    5: 'Lørdag',
    6: 'Søndag',
  },
  moment: {
    0: 'Morgen',
    1: 'Eftermiddag',
    2: 'Dag',
    3: 'Aften',
    hour: {
      0: '',
      1: '',
      2: '',
      3: '',
    },
  },
  openingMoment: {
    0: 'Lukket hele dagen',
    1: 'Kun åben om morgenen',
    2: 'Kun åben om eftermiddagen',
    3: 'Åben hele dagen',
    4: 'Helligdag',
    5: 'Regional helligdag',
    6: 'Obligatorisk åbningsdag',
  },
  dropdown: {
    label: {
      accessory: 'Vælg dit tilbehør',
      bouquet: 'Vælg buketten',
      city: 'Angiv byen',
      country: 'Vælg land',
      loginAs: 'Angiv blomsterhandlerkode',
      mail: 'Angiv din e-mail',
      messageContent: 'Angiv din besked',
      noteCategory: 'Notekategori',
      photoCategory: 'Fotokategori',
      occasion: 'Vælg lejlighed',
      receiveAnswerAt: 'Du vil modtage svaret på',
      select: 'Vælg årsagen',
      selectCategory: 'Vælg kategori',
      time: 'Vælg tidspunkt på dagen',
      type: 'Vælg typen',
      year: 'Vælg år',
      search: 'Søg...',
      locality: 'Vælg destination',
    },
    code: {
      ALL: 'Alle',

      // OBJECT OF THE MESSAGE
      CANCEL: 'Jeg vil gerne annullere min ordre',
      INFO: 'Jeg har brug for oplysninger til at behandle en ordre',
      HELP: ' Iris assistance',
      SUPPLY: 'Forsyningsordre',
      QUALITY: 'Kvalitetsbonus',
      SHOP1: 'Din butik (afvikling/opsigelse/nye kontaktoplysninger)',
      SHOP2: 'Din butik (tilbehør/skilt)',
      CALL: 'Opkald fra en sælger',
      INDEMNITY: 'Spørgsmål om din kompensationsopgørelse',
      CLAIM: 'Reklamationer/tvister',
      B2B: 'Erhvervsordrer B2B',

      // MOMENT
      0: 'Morgen',
      1: 'Eftermiddag',
      2: 'Dag',
      AFTERNOON: 'Eftermiddag',
      DAY: 'Dag',
      MORNING: 'Morgen',

      // EVENT
      BABY: 'Ny baby',
      BIRTHDAY: 'Fødselsdag',
      CONGRATULATIONS: 'Tillykke',
      FUNERALS: 'Begravelse',
      JUSTBECAUSE: 'Bare fordi',
      OTHER: 'Anden årsag',
      WEDDING: 'Bryllup',
      WELLSOON: 'Kom dig snart',

      // MAIL REASONS
      ADMIN: 'Spørgsmål om min administration',
      HARDWARE: 'Spørgsmål om problem med PC',
      INVOICEINCIDENT: 'Fakturaincident',
      ORDER: 'Spørgsmål om en ordre',
      ORDERINCIDENT: 'Ordreincident',
      ORDERMATERIAL: 'Materialeordre',
      PARTNER: 'Spørgsmål om mit partnerskab',
      SUGGESTION: 'Giv et forslag',

      // DOCUMENTS
      IT_DOC_ORDER_CART: 'Ordrekurv',
      IT_DOC_ORDER_RECEIVER: 'Ordremodtager',
      IT_DOC_ORDER_SENDER: 'Kundens indkøbsordre',
      IT_INVOICE_BALANCE: 'Saldofaktura(2024)',
      IT_INVOICE_PURCHASE: 'Indkøbsfaktura(2024)',
      IT_INVOICE_VENDOR: 'Leverandørfaktura(2024)',
      SP_INVOICE_COMMISSIONS_RECTIFY: 'Kommissionsjusteringsfaktura',
      SP_INVOICE_COMMISSIONS: 'Indkøbsgebyr/kommissionsfakturaer for blomsterhandlere',
      SP_INVOICE_EXECUTIONS_RECTIFY: 'Korrigerende indkøbsfakturaer for udførelser',
      SP_INVOICE_EXECUTIONS: 'Indkøbsfakturaer for udførelser',
      SP_INVOICE_EXTRACT: 'Sammenfatning af clearingdokument',
      SP_INVOICE_MATERIAL: 'Materialefaktura',
      SP_INVOICE_QUOTAS: 'Månedlige fakturagebyr for blomsterhandlere / Korrigerende fakturaer',
      SP_INVOICE_CSI_SALES: 'Faktura (afsluttede ordrer)',
      SP_INVOICE_QUOTAS_RECTIFY: 'Korrigerede fakturakvoter',
      PT_SAFT: 'Korrigerede fakturakvoter',
    },
  },

  notification: {
    title: 'Notifikationer',
    label: {
      order: 'ny ordre',
      orderPlural: 'nye ordrer',
      transmission: 'transmission',
      transmissionPlural: 'transmissioner',
      review: 'anmeldelse',
      reviewPlural: 'anmeldelser',
      modification: 'ændring',
      modificationPlural: 'ændringer',
      cancellation: 'annullering',
      cancellationPlural: 'annulleringer',
      refused: 'afvist ordre',
      refusedPlural: 'afviste ordrer',
      expired: 'udløbet ordre',
      expiredPlural: 'udløbne ordrer',
    },
    message: {
      hideNotification: 'Skjul notifikation',
      more: 'Se mere',
      orderPlural: 'Se ordreliste',
      transmissionPlural: 'Se transmissionsliste',
      reviewPlural: 'Se anmeldelser',
      modificationPlural: 'Se ordreliste',
      cancellationPlural: 'Skjul notifikation',
      refusedPlural: 'Skjul notifikation',
      expiredPlural: 'Skjul notifikation',
    },
    markAllAsRead: 'Marker alle som læst',
  },

  mail: {
    from: 'Besked fra blomsterhandler: ',
    subject: 'Emne: ',
    body: 'Besked: ',
    sended: 'E-mail sendt',
    notSended: 'Fejl ved afsendelse af e-mail',
  },

  billing: {
    notAllowed: 'Du er ikke autoriseret til at se disse oplysninger',
    header: {
      id: 'Nummer',
      date: 'Dato',
      numberOfTransmission: 'Antal transmissioner',
      amount: 'Beløb',
      type: 'Type',
      file: 'Fil',
    },
  },
  filter: {
    all: 'Alle',
    today: 'I dag',
    tomorrow: 'I morgen',
    later: 'Senere',
    past: 'Tidligere',
    toPrepare: 'Ordrer',
    inDelivery: 'Levering',
    absent: 'Fraværende',
    toAccept: 'Skal accepteres',
    inProgress: 'I gang',
    late: 'Forsinket',
    delivered: 'Leveret',
    activity: 'Min aktivitet',
    financial: 'Mine kompensationer',
    profiles: 'Mine kurerer',
    activCourier: 'Aktive kurerer',
    inactivCourier: 'Inaktive kurerer',
    allCourier: 'Alle kurerer',
    legal: 'Juridiske dokumenter',
    manageStore: 'Administrer min butik',
    bonus: 'Kvalitetsbonus',
    customer: 'Kundeordreformular',
    executingForm: 'Udførelsesordreformular',
    IT_DOC_ORDER_CART: 'Ordrekurv',
    IT_DOC_ORDER_RECEIVER: 'Ordremodtager',
    IT_DOC_ORDER_SENDER: 'Kundens indkøbsordre',
    IT_INVOICE_BALANCE: 'Saldofaktura(2024)',
    IT_INVOICE_PURCHASE: 'Indkøbsfaktura(2024)',
    IT_INVOICE_VENDOR: 'Leverandørfaktura(2024)',
    SP_INVOICE_COMMISSIONS_RECTIFY: 'Kommissionsjusteringsfaktura',
    SP_INVOICE_COMMISSIONS: 'Indkøbsgebyr/kommissionsfakturaer for blomsterhandlere',
    SP_INVOICE_EXECUTIONS_RECTIFY: 'Korrigerende indkøbsfakturaer for udførelser',
    SP_INVOICE_EXECUTIONS: 'Indkøbsfakturaer for udførelser',
    SP_INVOICE_EXTRACT: 'Sammenfatning af clearingdokument',
    SP_INVOICE_MATERIAL: 'Materialefaktura',
    SP_INVOICE_QUOTAS: 'Månedlige fakturagebyr for blomsterhandlere / Korrigerende fakturaer',
    SP_INVOICE_CSI_SALES: 'Faktura (afsluttede ordrer)',
    SP_INVOICE_QUOTAS_RECTIFY: 'Korrigerede fakturakvoter',
    PT_SAFT: 'Saft',
  },

  size: {
    label: 'Vælg størrelse',
    0: 'Unik pris',
    1: 'Lille',
    2: 'Stor',
    3: 'Ekstra stor',
    4: 'Fri pris',
    Standard: 'Standard',
    Premium: 'Premium',
    Deluxe: 'Deluxe',
    one_size: 'Unik pris',
    small: 'Lille',
    medium: 'Stor',
    large: 'Ekstra stor',
    null: 'Afhængig af prisen',
    Normal: 'Lille',
    Grande: 'Stor',
    Superior: 'Ekstra stor',
    Pequeño: '',
    Médio: '',
    Médium: 'Stor',
    Petit: 'Lille',
  },

  deliveryMode: {
    CEREMONY: 'Ceremoni',
    NO_ADDRESS: 'Ingen adresse',
    SELF: 'Selv',
    STANDARD: 'Standard',
    TOMB: 'Begravelse',
    FUNERAL_PLACE: 'Begravelse',
    GRAVE: 'Begravelse',
  },

  error: {
    floristUnknown: {
      title: 'Ukendt login',
      body: 'Den aktuelle konto er ugyldig: klik på log ud-knappen og vælg en anden konto.',
      button: 'Log ud',
    },
    noCountryCode: {
      title: 'Ukendt landekode',
      body: 'Ukendt landekode: klik på log ud-knappen og vælg en anden konto.',
      button: 'Log ud',
    },
  },

  soon: {
    kpi: "Kommer snart, find dine forretnings-KPI'er her",
    hourly: 'Kommer snart, find dine åbningstider her',
  },

  color: {
    blue: 'Blå',
    green: 'Grøn',
    mixed: 'Multifarvet',
    orange: 'Orange',
    pink: 'Pink',
    purple: 'Lilla',
    red: 'Rød',
    silver: 'Sølv',
    white: 'Hvid',
    yellow: 'Gul',
  },

  QrCode: {
    200: 'Ordren er leveret',
    400: 'Du kan ikke sætte ordrestatus til leveret',
    500: 'Der opstod en fejl, kontakt venligst Interflora',
  },

  internalUser: {
    any: 'Ingen blomsterhandler valgt',
    login: 'Log ind',
    needId: 'Du skal være tilknyttet en blomsterhandler for at se disse oplysninger',
    placeholder: 'Angiv blomsterhandlerkode',
    title: 'Log ind som',
    loggedIn: 'Du er logget ind som',
    backToAdmin: 'Tilbage til administratorområdet',
  },

  // DELIVERY STATUSES
  deliveryStatus: {
    scheduled: 'Planlagt',
    booked: 'Booket',
    pending: 'Søger chauffør',
    picking: 'Henter',
    almost_picking: 'Næsten ved at hente',
    waiting_at_pickup: 'Venter ved afhentning',
    delivering: 'Leverer',
    almost_delivering: 'Næsten ved at levere',
    waiting_at_dropoff: 'Venter ved aflevering',
    delivered: 'Leveret',
    no_courier_available: 'Ingen kurer tilgængelig',
    cancelled: 'Annulleret',
  },

  calendarExceptionType: {
    CountryForceOpen: 'Obligatorisk åbning',
    CountryHolidays: 'Nationale helligdage',
    DefaultDates: 'Åben',
    FloristCloseOnlyAfternoon: 'Kun lukket om eftermiddagen',
    FloristCloseOnlyMorning: 'Kun lukket om morgenen',
    FloristHoliday: 'Ferie',
    FloristOpenOnlyAfternoon: 'Kun åben om eftermiddagen',
    FloristOpenOnlyMorning: 'Kun åben om morgenen',
    FloristOpenWholeDay: 'Åben',
    RegionalHoliday: 'Regional helligdag',
  },

  month: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'Maj',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Okt',
    11: 'Nov',
    12: 'Dec',
  },
  lastsMonth: 'Seneste 12 måneder',
  kpi: {
    labelBestSeller: 'Antal salg',
    labelExecution: 'Udførelsesbeløb',
    labelNPS: 'NPS',
    labelNumberOfRefusal: 'Antal afvisninger',
    thisMonth: 'Denne måned',
    titleBestSeller: 'Dine bedste sælgere',
    titleExecution: 'Mine udførelser',
    tooltipExecution: 'Antal udførelser',
    noDataPeriod: 'Ingen data for denne periode',
    month: {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'Maj',
      5: 'Jun',
      6: 'Jul',
      7: 'Aug',
      8: 'Sep',
      9: 'Okt',
      10: 'Nov',
      11: 'Dec',
    },
  },
  locality: {
    FR: 'Frankrig (metropolitansk)',
    CORSE: 'Korsika',
    DOMTOM: 'Oversøiske områder',
  },

  compensation: {
    explanation: '',
    title: 'Min kompensation for ',
    fortnight: {
      1: '1. halvmåned',
      2: '2. halvmåned',
    },
    login: {
      title: 'Begrænset adgang',
      secretCode: 'Hemmelig kode:',
      placeholder: '12345',
      error: 'Forkert hemmelig kode',
    },
    recette: {
      download: 'Download results from',
    },
  },

  capping: {
    title: `Udførelseskapacitet`,
    adjustCapping: 'Juster kapacitetsgrænsen',
    daysBeforeEvent: `Begivenheden er om {count} dag{plural}`,
    needToBeSuperior: `I denne periode er det ikke muligt at reducere kapacitetsgrænsen under {minCapping}. Juster venligst værdien.`,
    ordersLeft: `{ordersLeft} ordrer tilbage inden kapacitetsgrænsen nås! Overvej at øge den maksimale kapacitetsgrænse.`,
    noOrdersLeft: `Du har nået din maksimale udførelseskapacitet. Overvej at øge den maksimale kapacitetsgrænse.`,
  },

  internalCourier: {
    createNewCourier: 'Tilføj en kurer',
    undefined: 'Ikke defineret',
    list: {
      headerTable: {
        courierProfile: 'Leverandør',
        courierId: 'Leverandørens identifikationsnummer',
        activationDate: 'Aktiveringsdato',
        deactivationDate: 'Deaktiveringsdato',
        actions: 'Handlinger',
      },
      statusSrOnly: {
        active: 'Aktiv leverandørprofil',
        inactive: 'Inaktiv leverandørprofil',
      },
      toggleStatus: {
        active: 'Aktivér profil',
        inactive: 'Deaktiver profil',
      },
      edit: 'Rediger profil',
      empty: {
        title: 'Der er endnu ikke oprettet nogen leverandørprofil.',
        text: 'Med leverandørprofilerne kan du tildele ordrer til dine interne leverandører.',
      },
    },
    create: {
      couriersInformation: 'Oplysninger om kureren',
      title: 'Opret en kurerprofil',
      name: 'Kurernavn*',
      nameAlreadyExistMessage: 'Dette navn er allerede taget. Tilføj noget (f.eks. et tal) for at gøre det unikt.',
      id: 'Kurerens login-id',
      idExplaination:
        'Identifikatoren giver denne profil mulighed for at logge ind på Iris. Den oprettes automatisk ud fra det indtastede navn og oplysningerne om din butik for at være unik.',
      profileCreated: 'Kureren er blevet oprettet.',
      profileNotCreated: 'Umuligt at oprette kureren',
      password: {
        label: 'Adgangskode*',
        confirmLabel: 'Bekræft adgangskoden*',
        confirmNotMatch: 'De to felter stemmer ikke overens.',
        rules: {
          uppercase: 'Et stort bogstav',
          lowercase: 'Et lille bogstav',
          number: 'Et tal',
          minCaracters: 'Mere end 10 tegn',
          specialCaracters: "Et specialtegn blandt ? ! - _ & % {'@'}",
        },
      },
      status: {
        title: 'Kurerens status',
        explanation: {
          activation: {
            default: `Kureren vil være aktiv fra den valgte aktiveringsdag.`,
            inactiv: 'Kureren vil være inaktiv.',
          },
          desactivation: {
            default: `Kureren vil være inaktiv fra den valgte deaktiveringsdag.`,
            notDefine: `Kureren forbliver aktiv, indtil du deaktiverer den.`,
          },
          tomorrowTooltip: `Deaktiveringsdatoen kan ikke være tidligere end aktiveringsdatoen.`,
        },
      },
      date: {
        activationTitle: `Aktiveringsdato*`,
        desactivationTitle: 'Deaktiveringsdato*',
        today: `I dag`,
        tomorrow: 'I morgen',
        otherDate: 'Anden dato',
        notDefine: 'Ikke defineret',
        endDateBeforeStartDate: 'Deaktiveringsdatoen kan ikke være tidligere end aktiveringsdatoen.',
      },
      error: {
        someFieldsNeedCorrection: 'Nogle oplysninger skal rettes. Tjek venligst de markerede felter.',
        someFieldsAreMissing: 'Nogle oplysninger mangler. Tjek venligst de markerede felter.',
        fieldRequired: 'Dette felt er obligatorisk.',
        impossibleToCreate: 'Det er ikke muligt at oprette kurerprofilen.',
      },
    },
    update: {
      title: 'Rediger en kurerprofil',
      profileUpdated: 'Kureren er blevet opdateret.',
      selectedCourier: 'Den valgte leverandør',
      cancelButton: 'Bevar planlægningen',
      activationButton: 'Aktivér',
      deactivationButton: 'Deaktiver',
      password: {
        edit: 'Rediger adgangskode',
        label: 'Ny adgangskode*',
        closeWithoutSaving: 'Luk uden at gemme',
      },
      error: {
        impossibleToUpdate: 'Det er ikke muligt at opdatere kurerprofilen.',
      },
      guidingMessage: {
        activation: 'Det ser ud til, at der allerede er planlagt en aktivering for denne mail!',
        deactivation: 'Det ser ud til, at denne mail allerede er blevet deaktiveret!',
        activationDate: 'Forventet aktiveringsdato:',
        deactivationDate: 'Planlagt deaktiveringsdato:',
        profileDeactivate: 'Leverandøren er blevet deaktiveret',
        profileActivate: 'Leverandøren er blevet aktiveret',
        disableActions:
          'For at ændre arbejdsperioden eller slette denne leverandør skal du først fjerne de ordrer, der er knyttet til vedkommende.',
      },
      modalTitle: {
        deactivation: 'Deaktiver leverandøren',
        activation: 'Aktivér leverandøren',
      },
    },
    delete: {
      title: 'Slet en kurerprofil',
      button: 'Slet denne kurer',
      bodyTitle: 'Er du sikker på, at du vil slette denne kurer permanent?',
      profileDeleted: 'Kureren er blevet slettet.',
      error: {
        impossibleToUpdate: 'Kan ikke slette kurerprofilen',
        activeOrders:
          'Denne leverandør har stadig aktive ordrer i gang. Annuller eller tildel disse ordrer til en anden fra fanen »Levering«, og prøv derefter igen.',
      },
    },
    assignation: {
      title: 'Intern levering',
      activeProfiles: '{n} aktiv profil på leveringsdagen',
      activeProfilesPlural: '{n} aktive profiler på leveringsdagen',
      noActiveProfiles: 'Ingen aktive bud',
      goToInternalCourierList: 'Åbn leverandøradministrationen',
    },
    deliveryTab: {
      isActiv: 'Intern',
      isInactiv: 'Inaktiv leverandør',
    },
    detail: 'Ordre håndteret internt',
  },

  xlPage: {
    productsStock: {
      action: 'Produkthandling',
      list: 'Produktliste',
      anyProduct: 'Ingen produkter',
      title: 'Produktstyring',
      selection: {
        flower: 'Blomster',
        gift: 'Gaver',
      },
    },
  },
  onboarding: {
    title: 'Vejledning',
    checkLater: 'Påmind senere',
    close: 'Luk',
    startGuide: 'Start',
    next: 'Næste',
    finishGuide: 'Forstået',
    readTime: 'Anslået tid: {minutes} min',
    recipientConfirmation: {
      welcome: {
        title: 'Vejledning - Nyheder',
        description: [
          'Vi har tilføjet nye værktøjer til din grænseflade for at gøre det nemmere at følge dine ordrer og leveringer. Lad os guide dig igennem, hvordan de fungerer!',
          'Nyhederne:',
          '1. SMS til modtageren',
          '2. Foto ved levering',
          '3. Forbedret visning',
        ].join('\n'),
      },
      step1: {
        title: 'Afsendelse af SMS til modtageren',
        description: [
          'Modtageren får automatisk en SMS, <strong>der beder dem bekræfte deres oplysninger, og at de er til stede på den ønskede dato og i det ønskede tidsrum.</strong>',
          'SMS-afsendelse: dagen før levering kl. 18 eller 30 min. efter købet for ordrer afgivet samme dag.',
          '<br />',
          'Spar tid: hvis modtageren har bekræftet, behøver du ikke ringe, før du kører ud og leverer!',
          'Ellers leverer du, som du gør i dag.',
        ].join('\n'),
      },
      step2: {
        title: 'SMS-statusser',
        description: [
          'SMS’en kan have flere statusser:',
          '1- "Bekræftet" via SMS - alt er i orden, ikonet bliver grønt',
          'Når det er bekræftet, kan modtageren ikke længere ændre disse oplysninger.',
          '2- "Bekræftet" via telefon - Du har talt med modtageren i telefonen, bekræft status manuelt',
          '3- "Sendt" - SMS’en er sendt',
          '4- "Gensendt" - gensend SMS’en med et enkelt klik for at give modtageren endnu en chance for at bekræfte.',
          '5- "Udløbet" - intet svar 1 time før leveringstidsrummet slutter, modtageren kan ikke længere tilføje oplysninger eller bekræfte -> du leverer, som du gør i dag',
        ].join('\n'),
      },
      step3: {
        title: 'Ny status "Klar"',
        description: [
          'Når produktet er færdigt, sætter du ordren til status "Klar" i iris: du er klar til at levere den.',
          'Bemærk: ',
          '- når status "Klar" er aktiveret, kan modtageren ikke længere tilføje oplysninger',
          '- denne status er tilgængelig på leveringsdagen, fra 2 timer før leveringstidsrummet starter',
        ].join('\n'),
      },
      step4: {
        title: 'Opdateringer af ordreoplysninger',
        description: [
          'Hvis modtageren tilføjer oplysninger, eller hvis ordren ændres, vises det lilla «i»-ikon.',
          'Få adgang til en ordres ændringshistorik med et enkelt klik.',
          'Klik på «i»-ikonet fra ordrelisten for at se, hvad der er ændret, og markér ændringen som set.',
          'Disse oplysninger kan altid ses igen.',
        ].join('\n'),
      },
      step5: {
        title: 'Modtageren accepterer levering i sit fravær',
        description: [
          'Modtageren kan acceptere, at ordren afleveres i deres fravær, eventuelt med supplerende oplysninger. F.eks.: hos naboen, foran døren, bag lågen til højre...',
          'Find disse oplysninger på ordrens detaljeside eller via «i»-ikonet',
          'I dette tilfælde <strong>kræves der et foto ved leveringen, uden synlige ansigter. Det beskytter dig i tilfælde af en tvist.</strong>',
        ].join('\n'),
      },
      step6: {
        title: 'Hvordan tager man fotoet?',
        description:
          'Når du bekræfter leveringen, vises en skærm. Husk at rulle ned via sidebjælken for at få FOTO-muligheden frem',
      },
      step7: {
        title: 'Sporing af udskrifter',
        description: 'Fra ordrelisten kan du på et øjeblik se, om dine ordrer er blevet udskrevet.',
      },
      step8: {
        title: 'Mere synlige statusfarver',
        description:
          'Farven er blevet forstærket på visse dele af ordrelinjerne for bedre at skelne mellem statusser, uden at gøre resten af linjen sværere at læse.',
      },
    },
  },
};
